package com.exura.features.plandefinition.demosets.neuca

import com.exura.features.plandefinition.domain.model.collection.Collection
import com.exura.features.plandefinition.domain.model.plan.TreatmentPlan
import com.exura.features.plandefinition.domain.model.series.*

val YearlyLongevityProgram = TreatmentPlan(
    firebaseDocId = null,
    firebaseDocPrefix = null,
    imageUrl = "https://firebasestorage.googleapis.com/v0/b/exura-be.firebasestorage.app/o/organization%2FcEbVTwEBZVc0ZkD2elG717zVaH63%2Fplan_definition_images%2F1768495513941_neuca_logo.svg?alt=media&token=f1ce1be7-26d3-4a9e-8894-901d11d11f48",
    title = "Roczna ścieżka Longevity",
    description = "Kompleksowy program zarządzania wiekiem biologicznym dla klienta subskrypcyjnego. Obejmuje diagnostykę, edukację, zmianę nawyków oraz opcje rozszerzone (FFS).",
    collections = listOf(

        // =================================================================================
        // LAYER 1: PATH NAVIGATION - VISITS AND TESTS
        // =================================================================================
        Collection(
            name = "Nawigacja procesu medycznego",
            description = "Kluczowe punkty styku ze specjalistami oraz diagnostyka laboratoryjna.",
            relativeDay = 0,
            series = listOf(
                SimpleInstructionSeries(
                    title = "Piersza telekonsultacja z profilaktykiem",
                    description = "Rozpoczynamy od wywiadu. Profilaktyk to Twój przewodnik – pomoże Ci zrozumieć logistykę programu i wstępnie oceni Twój styl życia. Nie musisz się przygotowywać, po prostu bądź. Klikaj poniżej i przejdź bezpośrednio do kalendarza.",
                    relativeDay = 3,
                    spawnCount = 1,
                    instruction = "Umów pierwszą telekonsultację",
                    estimatedMinutes = 5,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Badania krwi",
                    description = "Kluczowy moment – pobranie materiału do analizy wieku biologicznego. Aby wynik był wiarygodny, bądź na czczo (min. 12h) i unikaj intensywnego sportu dzień wcześniej. Kliknij, by wybrać punkt pobrań.",
                    relativeDay = 45,
                    spawnCount = 1,
                    instruction = "Umów badania krwi",
                    estimatedMinutes = 5,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Telekonsultacja z lekarzem",
                    description = "Mamy Twój Raport Wieku Biologicznego! Spotkaj się ze specjalistą długowieczności. Omówicie wyniki i otrzymasz Indywidualny Plan Zdrowotny dla Długiego Życia. To najważniejsza wizyta w roku. Kliknij poniżej, aby zobaczyć dostępne terminy i umówić wizytę.",
                    relativeDay = 90,
                    spawnCount = 1,
                    instruction = "Umów wizytę z lekarzem",
                    estimatedMinutes = 5,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Druga telekonsultacja z profilaktykiem",
                    description = "Czas sprawdzić, czy wprowadzone zmiany przynoszą efekty. Porozmawiaj z profilaktykiem na temat swojego Planu Zdrowotnego dla Długiego życia. Skoryguj kurs i utrzymaj motywację. Klikając poniżej i umów wizytę.",
                    relativeDay = 150,
                    spawnCount = 1,
                    instruction = "Umów wizytę kontrolną",
                    estimatedMinutes = 5,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
            )
        ),

        // =================================================================================
        // LAYER 2: USER INPUTS - REQUESTS FOR QUESTIONNAIRES AND REPORTS, NO DIRECT INTERACTION
        // =================================================================================
        Collection(
            name = "Twoje Dane i Wyniki",
            description = "Ankiety i raporty, które budują Twój profil zdrowotny.",
            relativeDay = 60,
            series = listOf(
                SimpleInstructionSeries(
                    title = "Pierwsza Ankieta Długowieczności",
                    description = "Ankieta składa się z kilku pytań o Twoją codzienność i nawyki. Twoje odpowiedzi są nie tylko kluczowe dla lekarza, aby wiedzieć jak ulepszyć Twoją codzienność, ale mogą też wskazać obszary do poprawy już teraz. Ankietę wypełnisz klikając poniżej.",
                    relativeDay = 0,
                    spawnCount = 1,
                    instruction = "Wypełnij ankietę Długowieczności",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.EVENING),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Ankieta Długowieczności - kolejne",
                    description = "Do ankiety długowieczności warto wrócić co jakiś czas! Zobacz, gdzie udało Ci się zrobić postępy i jak poprawił się Twój wynik. Ankietę wypełnisz poniżej:",
                    relativeDay = 60,
                    spawnForDays = 240,
                    instruction = "Sprawdź odpowiedzi w ankiecie Długowieczności",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 60,
                ),
                SimpleInstructionSeries(
                    title = "Raport wieku biologicznego",
                    description = "Raport wieku bilogicznego to wynik badania laboratoryjnego, który analizuje różne aspekty Twojego organizmu, aby powiedzieć Ci, czy jesteś młodszy niż wskazuje na to metryka. Niski wiek biologiczny, to długie i aktywne życie. Raport zamówisz klikając poniżej:",
                    relativeDay = 10,
                    spawnCount = 1,
                    instruction = "Zamów raport wieku bilogicznego",
                    estimatedMinutes = 20,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleQuestionSeries(
                    title = "Szybki Check-in nawykowy",
                    description = "Małe kroki tworzą wielkie zmiany. Zanim przejdziesz do kolejnego etapu, zastanów się nad ostatnim miesiącem.",
                    relativeDay = 60,
                    duration = 240,
                    question = "Czy w tym miesiącu udało Ci się utrzymać zalecenia z Planu Zdrowotnego w min. 70%?",
                    reaskEveryDays = 30,
                    options = listOf(
                        SimpleQuestionSeries.QuestionOption("yes", "Tak", "Fantastycznie! Konsekwencja to klucz do cofania zegara biologicznego.", true),
                        SimpleQuestionSeries.QuestionOption("no", "Nie", "Nie szkodzi. Wróć do materiałów edukacyjnych z tego miesiąca i spróbuj ponownie.", false)
                    ),
                    estimatedMinutes = 2,
                )
            )
        ),

        // =================================================================================
        // LAYER 3: FFS SOFT OFFERING
        // =================================================================================
        Collection(
            name = "Oferta Rozszerzona i Podsumowanie",
            description = "Możliwości pogłębienia diagnostyki oraz podsumowanie roku.",
            relativeDay = 180,
            series = listOf(
                SimpleQuestionSeries(
                    title = "Odczuwalna poprawa stanu",
                    description = "Pamiętajmy, że celem procesu jest zapewnić Ci długie i jakościowe życie. Jeśli chcesz sprawdzić jak Ci idzie, możesz skorzystać ze specjalnej oferty na ponad programowy raport wieku bilogicznego, dostępnej poniżej:",
                    relativeDay = 60,
                    duration = 120,
                    question = "Czy czujesz, że udało Ci się spowolnić wzrost wieku biologicznego?",
                    reaskEveryDays = 30,
                    options = listOf(
                        SimpleQuestionSeries.QuestionOption(
                            id = "yes",
                            text = "Yes",
                            responseMessage = "To świetna informacja! Pamiętaj, że możesz sprawdzić swój postęp, zamawiając dodatkowy, odpłatny raport.",
                            isResponsePositive = true,
                        ),
                        SimpleQuestionSeries.QuestionOption(
                            id = "no",
                            text = "No",
                            responseMessage = "To przykra informacja. Czy jest powód, dla którego tak uważasz? Możesz go zapisać i umówić dodatkową, odpłatną wizytę z profilaktykiem.",
                            isResponsePositive = false,
                        )
                    ),
                ),
                SimpleQuestionSeries(
                    title = "Pakiet badań krwi",
                    description = "W ramach ścieżki długowieczności możesz we własnym zakresie wybrać pakiet z większą liczbą badań, który pozwala uzyskać dokładniejsze rezultaty. Zapoznaj się z możliwościami poniżej:",
                    relativeDay = 0,
                    duration = 180,
                    question = "Czy wiesz który pakiet badań krwi oferuje Twój pracodawca?",
                    reaskEveryDays = 90,
                    options = listOf(
                        SimpleQuestionSeries.QuestionOption(
                            id = "yes",
                            text = "Yes",
                            responseMessage = "To bardzo dobrze! Pamiętaj, że możesz z nim porozmawiać o rozszerzeniu zakresu w kolejnym roku lub samodzielnie wybrać bogatszą opcję.",
                            isResponsePositive = true,
                        ),
                        SimpleQuestionSeries.QuestionOption(
                            id = "no",
                            text = "No",
                            responseMessage = "Możesz zapoznać się z możliwościami przez przycisk w opisie i dzięki temu dowiedzieć się, co pracodawca może zaoferować Ci w kolejnym roku.",
                            isResponsePositive = true,
                        )
                    ),
                ),
                SimpleInstructionSeries(
                    title = "Certyfikat Postępów",
                    description = "Gratulacje! Zbliżasz się do końca rocznego cyklu. Wygenerowaliśmy raport podsumowujący Twoje sukcesy. Pobierz go – to świetny argument dla Twojego pracodawcy, by przedłużył program na kolejny rok!",
                    relativeDay = 180,
                    spawnCount = 1,
                    instruction = "Pobierz Certyfikat Longevity",
                    estimatedMinutes = 5,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                )
            )
        ),
        // =================================================================================
        // LAYER 4: EDUCATIONAL PROMPTS - ROLLING SERIES OF ACTIONABLE EDU INFORMATION
        // =================================================================================
        Collection(
            name = "Warstwa samodzielnej obsługi - ankiety i raporty",
            description = "Wszystkie zadania jakie użytkowink musi wykonać samodzielnie.",
            relativeDay = 0,
            series = listOf(
                SimpleInstructionSeries(
                    title = "Wprowadzenie do programu",
                    description = "Długowieczność to nie tylko 'życie długo', to życie w pełnej sprawności do samego końca. Ten program to Twoja nawigacja po zdrowiu. Pobierz przewodnik startowy, aby wiedzieć, co Cię czeka.",
                    relativeDay = 1,
                    spawnCount = 1,
                    instruction = "Przeczytaj: Jak korzystać z programu?",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Czym jest wiek biologiczny?",
                    description = "Możesz mieć 40 lat 'z dowodu', ale Twój organizm może pracować jak u 50-latka – lub 30-latka! Zrozumienie tej różnicy to pierwszy krok do cofnięcia zegara. Obejrzyj krótkie wideo wyjaśniające.",
                    relativeDay = 61,
                    spawnCount = 1,
                    instruction = "Obejrzyj: Czym jest Wiek Biologiczny?",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Stan zdrowia i dbałość o zdrowie",
                    description = "Medycyna naprawcza wkracza, gdy jest za późno. Lepiej postawić na prewencję. Dowiedz się, jakie małe zmiany w codzienności dają największy zwrot z inwestycji w Twoje zdrowie.",
                    relativeDay = 91,
                    spawnCount = 1,
                    instruction = "Poznaj: Podstawy dbania o zdrowie",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Aktywność fizyczna",
                    description = "Nie musisz katować się na siłowni. Badania pokazują, że regularny spacer i unikanie siedzenia >1h ciągiem dają spektakularne efekty dla serca.",
                    relativeDay = 121,
                    spawnCount = 1,
                    instruction = "Zadbaj o wiedzę na temat aktywności fizycznej",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Nawyki żywieniowe",
                    description = "To nie tłuszcz jest wrogiem, a gwałtowne skoki cukru, które przyspieszają starzenie komórek. Poznaj sposoby, jak jeść to co lubisz, ale z mniejszą szkodą dla organizmu.",
                    relativeDay = 151,
                    spawnCount = 1,
                    instruction = "Zrozum nawyki żywieniowe i jak je poprawić",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Alkohol i papierosy",
                    description = "Alkohol i papierosy to najszybsze dopalacze wieku biologicznego. Bez kazań – po prostu pokażemy Ci dane, jak 30 dni detoksu wpływa na Twoj organizm.",
                    relativeDay = 181,
                    spawnCount = 1,
                    instruction = "Obejrzyj: Biologiczny koszt nałogu",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Sen",
                    description = "Podczas snu Twój mózg usuwa toksyny nagromadzone w ciągu dnia. Zobacz, jak przygotować sypialnię do regeneracji.",
                    relativeDay = 211,
                    spawnCount = 1,
                    instruction = "Pobierz checklistę Higieny Snu",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Masa ciała",
                    description = "Waga to tylko liczba, ale skład ciała to Twoja przyszłość. Nadmiar tłuszczu trzewnego działa jak oddzielny narząd produkujący stany zapalne. Poznaj metody kontroli wagi, które stabilizują metabolizm bez głodówek.",
                    relativeDay = 241,
                    spawnCount = 1,
                    instruction = "Zapoznaj się z metodami kontroli masy ciała",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Markery z krwi",
                    description = "Parametry takie jak lipidogram czy hemoglobina glikowana ostrzegają o problemach na lata przed objawami. Naucz się interpretować te wyniki, by nie dać się zaskoczyć.",
                    relativeDay = 271,
                    spawnCount = 1,
                    instruction = "Zrozum markery krwi",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Ciśnienie tętnicze krwi",
                    description = "Nadciśnienie nie boli, ale po cichu niszczy Twoje naczynia i nerki. To 'cichy zabójca' długowieczności. Dowiedz się, jak prawidłowo mierzyć ciśnienie w domu i jakie są normy dla Twojego wieku.",
                    relativeDay = 301,
                    spawnCount = 1,
                    instruction = "Dowiedz się czym jest ciśnienie tętnicze krwi i jak sobie z nim radzić",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
                SimpleInstructionSeries(
                    title = "Podsumowanie roku programu",
                    description = "To był rok pełen wiedzy i zmian. Spójrz wstecz na swoje wyniki badań i samopoczucie. Czy czujesz różnicę? Czas zaplanować kolejny rok!",
                    relativeDay = 361,
                    spawnCount = 1,
                    instruction = "Zobacz swoj rok w długowieczności",
                    estimatedMinutes = 15,
                    partsOfDay = listOf(PartOfDay.TODAY),
                    spawnEveryDays = 1,
                ),
            )
        ),
    ),

    directSeries = listOf(
        SimpleInstructionSeries(
            title = "Wiadomość powitalna",
            description = "Zaczynamy Twoją podróż po zdrowie. Ta aplikacja poprowadzi Cię krok po kroku – od badań, przez plan, aż po nowe nawyki.",
            relativeDay = 0,
            spawnCount = 1,
            instruction = "Witaj w programie długowieczności",
            estimatedMinutes = 15,
            partsOfDay = listOf(PartOfDay.TODAY),
            spawnEveryDays = 1,
        ),
    )
)
